/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FullRemix } from './FullRemix';
import {
    FullRemixFromJSON,
    FullRemixFromJSONTyped,
    FullRemixToJSON,
} from './FullRemix';

/**
 * 
 * @export
 * @interface FullRemixParent
 */
export interface FullRemixParent {
    /**
     * 
     * @type {Array<FullRemix>}
     * @memberof FullRemixParent
     */
    tracks?: Array<FullRemix>;
}

/**
 * Check if a given object implements the FullRemixParent interface.
 */
export function instanceOfFullRemixParent(value: object): value is FullRemixParent {
    let isInstance = true;

    return isInstance;
}

export function FullRemixParentFromJSON(json: any): FullRemixParent {
    return FullRemixParentFromJSONTyped(json, false);
}

export function FullRemixParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullRemixParent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(FullRemixFromJSON)),
    };
}

export function FullRemixParentToJSON(value?: FullRemixParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(FullRemixToJSON)),
    };
}

